import { render, staticRenderFns } from "./ListItemSavedLocation.vue?vue&type=template&id=15049e21&scoped=true&lang=pug"
import script from "./ListItemSavedLocation.vue?vue&type=script&lang=js"
export * from "./ListItemSavedLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15049e21",
  null
  
)

export default component.exports